export default {
  purchasetransaction: [
    {
      id: 1,
      Bill: "INV-001",
      Customer: "Orn LLCorn@example.com",
      CreatedOn: "15 Dec 2023, 04:35 PM",
      Amount: "$299.99",
      Status: "Paid",
      Mode: "CASH",
      Action:
        "View\n                                        \n                                      \n                                      \n                                        \n                                          \n                                          Cancel\n                                        \n                                      \n                                      \n                                        \n                                          \n                                            \n                                            Subscription",
    },
    {
      id: 2,
      Bill: "INV-005",
      Customer: "Accent Technologyaccent@example.com",
      CreatedOn: "15 Dec 2023, 04:35 PM",
      Amount: "$299.99",
      Status: "Paid",
      Mode: "UPI",
      Action:
        "View\n                                        \n                                      \n                                      \n                                        \n                                          \n                                          Cancel\n                                        \n                                      \n                                      \n                                        \n                                          \n                                            \n                                            Subscription",
    },
    {
      id: 3,
      Bill: "INV-101",
      Customer:
        "Express Advertising\n                                    express@example.com",
      CreatedOn: "04 Dec 2023, 12:38 PM",
      Amount: "$299.99",
      Status: "Paid",
      Mode: "UPI",
      Action:
        "View\n                                        \n                                      \n                                      \n                                        \n                                          \n                                          Cancel\n                                        \n                                      \n                                      \n                                        \n                                          \n                                            \n                                            Subscription",
    },
    {
      id: 4,
      Bill: "INV-421",
      Customer:
        "Lexicon Technologies\n                                    lexicon@example.com",
      CreatedOn: "28 Nov 2022, 03:25 PM",
      Amount: "$299.99",
      Status: "Paid",
      Mode: "CHEQUE",
      Action:
        "View\n                                        \n                                      \n                                      \n                                        \n                                          \n                                          Cancel\n                                        \n                                      \n                                      \n                                        \n                                          \n                                            \n                                            Subscription",
    },
    {
      id: 5,
      Bill: "INV-321",
      Customer: "Sumo Soft Limited sumo@example.com",
      CreatedOn: "20 Nov 2023, 02:47 PM",
      Amount: "$299.99",
      Status: "Pending",
      Mode: "-",
      Action:
        "View\n                                        \n                                      \n                                      \n                                        \n                                          \n                                          Cancel\n                                        \n                                      \n                                      \n                                        \n                                          \n                                            \n                                            Subscription",
    },
    {
      id: 6,
      Bill: "INV-333",
      Customer: "Repair Group Corepair@example.com",
      CreatedOn: "15 Nov 2022, 10:42 AM",
      Amount: "$299.99",
      Status: "Pending",
      Mode: "-",
      Action:
        "View\n                                        \n                                      \n                                      \n                                        \n                                          \n                                          Cancel\n                                        \n                                      \n                                      \n                                        \n                                          \n                                            \n                                            Subscription",
    },
  ],
};
